import { render } from "./servingPenetrateModel.vue?vue&type=template&id=006b8dc8"
import script from "./servingPenetrateModel.vue?vue&type=script&lang=js"
export * from "./servingPenetrateModel.vue?vue&type=script&lang=js"

import "./servingPenetrateModel.vue?vue&type=style&index=0&id=006b8dc8&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__